import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import Tag from '../../../../../atoms/Tag';
import css from './ProductTag.module.scss';

interface Props {
  scheme: number;
}

const ProductTag = ({ scheme }: Props) => {
  const intl = useIntl();
  // TODO: remove this logic after implement model
  const isSubscription = scheme === 0;
  const isTicketBook = scheme === 1;

  if (!isSubscription && !isTicketBook) {
    return null;
  }

  const classes = () =>
    classNames(
      css.ProductTag,
      { [css.isTicketBook]: isTicketBook },
      { [css.isSubscription]: isSubscription },
    );
  const intlId = isSubscription ? 'subscription' : 'ticketBook';

  return (
    <Tag className={classes()}>
      {intl.formatMessage({
        id: `product.scheme.${intlId}`,
      })}
    </Tag>
  );
};

export default ProductTag;
